export enum FavoritesShareButtonStateEnum {
	COPIED = 'COPIED',
	DEFAULT = 'COPY',
	DEFAULT_PRIVATE = 'SET LIST TO PUBLIC'
}
